import { GetDealByIdQuery } from '@/lib/graphql/generated/graphql';
import { ApolloError } from '@apollo/client';
import { atom } from 'jotai';

export type DealFromQuery = NonNullable<GetDealByIdQuery['deal']>;

export const dealAtom = atom<DealFromQuery | null>(null);
export const dealErrorAtom = atom<ApolloError | undefined>(undefined);
export const dealRefetchAtom = atom<{ fn: () => Promise<void> }>({
  fn: async () => {},
});
// Tracks which dealId is currently loaded in dealAtom (to skip redundant fetches on navigation)
export const dealLoadedForIdAtom = atom<string | null>(null);
